import store from "../store";

export default function authenticated({ next, router }) {
    if (store.getters.loggedIn) {
      return router.push({ name: 'Dashboard' });
    }
  
    return next();
}